module.exports = __webpack_public_path__ + "static/media/60 colors deal.033690fe.png";